import React from "react";
import { Button, Stack } from "@mui/material";
import WBTextField from "components/input/WBTextField";
import { useForm } from "react-hook-form";
import { emailValidations, irMobileValidations } from "services/utils/Validation";
import useFetch from "services/hooks/useFetch";
import { ApiUrls } from "services/utils/globalVariables";
import { LoginHeading, LoginLabel } from "components/typography/text";
import { toast } from "react-toastify";
import persianToLatinDigits from "services/utils/PersiantoLatin";

export default function LoginFormNumber({ setLoading, setLoginData, setStage, loginData }) {

    const [{}, doFetch] = useFetch(ApiUrls.CheckUserName, "post")
    const { handleSubmit, control, setError, clearErrors } = useForm();

    const submitLoginInput = (data) => {
        //Setting button loading to true to activate loading
        setLoading(true)
        //Static body for object
        const staticBody = {
            "UserName": persianToLatinDigits(data.Login),
            "SmsToken": "asse212dlc@sdx",
            "SmsMessage": "پاک سرشت هوم",
            "IsDynamicPass": true,
            "PortalId": "0",
            "MergeUsers": false
        }

        if (irMobileValidations(data.Login) == true) {
            //User login information is number
            let bodyObj = {...staticBody, "IsPhoneNumber": true,}
            doFetch(bodyObj, (res) => {
                //New code send to user
                if(res == "CodeCreated") {
                    //Setting button loading to false to stop loading
                    setLoading(false)
                    setLoginData(data.Login)
                    setStage(2)
                }

                //Throw and error if user is Locked
                if(res == "UserLocked" || res === "TooManyRequestsError") {
                    toast.error("تلاش بیش از حد برای ورود. لطفاً کمی صبر کنید و مجدداً تلاش کنید")
                    setLoading(false)
                }

            })
        } else {
            //User login information is username
            let bodyObj = {...staticBody, "IsPhoneNumber": false,}
            doFetch(bodyObj, (res) => {
                //Throw an error if user typed invalid username
                if(res == "MobileNumberRequired") {
                    setError("Login", { type: "custom", message: "نام کاربری نادرست است." })
                    setLoading(false)
                } else {
                    clearErrors("Login")
                    setLoading(false)
                }

                //User must type its password
                if(res == "StaticCode") {
                    //Setting button loading to false to stop loading
                    setLoginData(data.Login)
                    setStage(4)
                    setLoading(false)
                }
            })
        }
    }


    const customeHandleValidation = (val) => {
        const patternNumber = /^[0-9]+$/;
        const patternSpchars = /[ `!#$%^&*()+\=\[\]{};':"\\|,<>\/?~]/;

        if (patternNumber.test(val)) {
            return irMobileValidations(val)
        } else if(patternSpchars.test(val)) {
            return false || "نام کاربری حاوی کاراکتر های غیرمجاز است"
        } else if(val.includes("@") || val.includes(".")) {
            return emailValidations(val)
        } else {
            return true
        }

    }

    return (
        <Stack spacing={2}>
            <LoginHeading>ورود | ثبت نام</LoginHeading>
            <LoginLabel>شماره موبایل خود را وارد کنید</LoginLabel>
            <Stack
                component="form"
                onSubmit={handleSubmit(submitLoginInput)}
            >
                <WBTextField
                    control={control}
                    type="number"
                    name="Login"
                    defualtValue={loginData}
                    isRequired={true}
                    autoComplete="off"
                    handleValidation={{validate: value => customeHandleValidation(value)}}
                    autoFocus={true}
                />
                <Button sx={{display: "none !important"}} id="SubmitNumber" type="submit">submitData</Button>
            </Stack>
        </Stack>
    )
}